import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { NotFoundContent } from './404';

import { DEFAULT_LOCALE, isAppLocale, type AppLocale } from '~/utils/i18n';

interface LocaleContext {
  locale: AppLocale;
  isInvalidLocale?: boolean;
}

const LocaleLayout = () => {
  Route.useRouteContext() as LocaleContext;
  return <Outlet />;
};

const LocaleComponent = () => {
  const context = Route.useRouteContext() as LocaleContext;

  // If invalid locale, show 404 instead of layout
  if (context.isInvalidLocale) {
    return <NotFoundContent />;
  }

  return <LocaleLayout />;
};

export const Route = createFileRoute('/$locale')({
  beforeLoad: ({ params, context, location }) => {
    const requested = params.locale?.toLowerCase();

    if (requested === 'ua' && location.pathname.replace(/\/$/, '') === '/ua') {
      throw redirect({ to: '/', replace: true });
    }

    // Use provided locale or default
    const locale =
      requested && isAppLocale(requested) ? requested : DEFAULT_LOCALE;

    const extendedContext: LocaleContext = {
      ...context,
      locale,
      // Flag to indicate if this is an invalid locale
      isInvalidLocale: requested ? !isAppLocale(requested) : false,
    };

    return extendedContext;
  },
  component: LocaleComponent,
});
